<template>
  <div class="body-container container">
    <div class="body-box-top">
      <div class="left-box">
        <!-- 使用 v-for 循环遍历数据 -->
        <div
          class="left-item"
          :class="{ active: current == 1 }"
          v-for="item in this.treeList"
          @click="handlerNavigation()"
          :key="item.value"
        >
          <!-- 导航栏 -->
          <div class="label">{{ item.name }}</div>
          <div class="menu-panel">
            <!-- 页面的顶部数据 -->
            <div class="panel-title">{{ item.name }}</div>
            <div class="panel-item">
              <!-- 遍历子数据 -->
              <div
                class="item"
                :model="particulars"
                v-for="childItem in item.children"
                @click="handlerNavigationParticulars(childItem.name)"
                :key="childItem.value"
              >
                {{ childItem.name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 弹窗 点击 子数据 显示的数据 -->
        <el-dialog
          :title="this.title"
          :visible.sync="dialogVisible"
          :fullscreen="true"
          :before-close="handleClose"
        >
          <div class="search-res">
            <div class="left-box-two" v-if="recruitNoticeList.length > 0">
              <div
                class="res-item"
                v-for="(item, index) in recruitNoticeList"
                :key="index"
              >
                <div class="top-res">
                  <div class="title-two">
                    {{ item.title }}
                  </div>
                  <div class="date-two">发布时间: {{ item.publishTime }}</div>
                </div>
                <div class="top-res">
                  <div class="type">
                    当前阶段: {{ item.statusName }} | 招聘岗位:
                    <span> {{ item.postNum }}</span> | 招聘人数:
                    <span> {{ item.totalNumber }}</span>
                  </div>
                  <div
                    :class="item.status == 2 ? 'button-over' : 'button-start'"
                    @click="goTo(item.id, item.status)"
                  >
                    {{ item.statusName }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="width: 100%">
              <el-divider content-position="center">暂无数据</el-divider>
            </div>
          </div>
          <!-- 底部按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>

        <!-- 这里不动 -->
        <div
          class="left-item"
          :class="{ active: current == 9 }"
          @click="handler(2)"
        >
          <div class="label">全部职位类型</div>
        </div>
      </div>
      <div class="swiper-box">
        <div class="swiper-container" style="height: 100%">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerList"
              :key="index"
              @click="goDetail(item)"
            >
              <img :src="item.advUrl" style="width: 100%; height: 100%" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="right-box">
        <div class="tabs">
          <div
            class="tab-item"
            @click="handleIndex(0)"
            :class="{ active: currentIndex == 0 }"
          >
            <img
              v-if="currentIndex != 0"
              src="../../assets/newImg/1.png"
              alt=""
            />
            <img
              v-if="currentIndex == 0"
              src="../../assets/newImg/1_active.png"
              alt=""
            />
            <div class="text">企业简介</div>
          </div>
          <!-- <div
            class="tab-item"
            @click="handleIndex(1)"
            :class="{ active: currentIndex == 1 }"
          >
            <img v-if="currentIndex != 1" src="../../assets/newImg/2.png" alt="" />
            <img v-if="currentIndex == 1" src="../../assets/newImg/2_active.png" alt="" />
            <div class="text">通知公告</div>
          </div>
          <div
            class="tab-item"
            @click="handleIndex(2)"
            :class="{ active: currentIndex == 2 }"
          >
            <img v-if="currentIndex != 2" src="../../assets/newImg/3.png" alt="" />
            <img v-if="currentIndex == 2" src="../../assets/newImg/3_active.png" alt="" />
            <div class="text">录用通知</div>
          </div> -->
        </div>
        <div class="tabs-content">
          <!-- 企业简介 -->
          <div
            class="tabs-content-qyjj"
            v-if="currentIndex == 0"
            v-html="enterpriseText"
          ></div>
          <!-- 通知公告 -->
          <div class="tabs-content-tzgg" v-if="currentIndex == 1">
            <template v-if="groupNews.length > 0">
              <router-link
                :to="{
                  path: '/newsDetail',
                  query: { id: item.id },
                }"
                class="tzgg-item"
                v-for="(item, index) in groupNews"
                :key="index"
              >
                <div class="news-title">
                  {{ item.title }}
                </div>
                <div class="date">{{ item.publishTime }}</div>
              </router-link>
            </template>
            <div v-else style="width: 100%">
              <el-divider content-position="center">暂无数据</el-divider>
            </div>
            <!-- path: '/newsList', -->
            <!-- path: '/newsListInform', -->
            <router-link
              class="more-tip"
              :to="{
                path: '/newsListInform',
                query: {
                  categoryId: currentIndex == 2 ? 3 : 2,
                },
              }"
              >更多>>
            </router-link>
          </div>
          <!-- 录用通知 -->
          <div class="tabs-content-lytz" v-if="currentIndex == 2">
            <template v-if="noticeNews.length > 0">
              <router-link
                :to="{
                  path: '/newsDetail',
                  query: { id: item.id },
                }"
                class="tzgg-item"
                v-for="(item, index) in noticeNews"
                :key="index"
              >
                <div class="news-title">
                  {{ item.title }}
                </div>
                <div class="date">{{ item.publishTime }}</div>
              </router-link>
            </template>
            <div v-else style="width: 100%">
              <el-divider content-position="center">暂无数据</el-divider>
            </div>
            <!-- path: '/newsListHire', -->
            <router-link
              class="more-tip"
              :to="{
                path: '/newsListHire',
                query: {
                  categoryId: currentIndex == 3 ? 2 : 3,
                },
              }"
              >更多>>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="body-box-banner">
      <img
        v-for="(item, index) in middleImageList"
        :key="index"
        :src="item.advUrl"
        @click="goDetail(item)"
      />
    </div>
    <!-- 通知公告 -->

    <!-- 录用通知 -->
    <!-- <div class="body-box-lytz"> -->
    <!-- Top -->
    <!-- <div class="lytz-text">
      <div></div>
      <div class="lytz-title">录用通知</div>
      <div class="lytz-more">
        <router-link
          class="more-tip"
          :to="{
            path: '/newsListHire',
            query: {
              categoryId: currentIndex == 3 ? 2 : 3,
            },
          }"
          >更多>></router-link
        >
      </div>
    </div> -->
    <!-- 列表数据 -->
    <!-- <div class="lytz-list">
      <div class="list-yes" v-if="noticeNews.length > 0">
        <template>
          <router-link
            :to="{
              path: '/newsDetail',
              query: { id: item.id },
            }"
            class="tzgg-item"
            v-for="(item, index) in noticeNews"
            :key="index"
          >
            <div class="news-title">
              {{ item.title }}
            </div>
            <div class="date">{{ item.publishTime }}</div>
          </router-link>
        </template>
      </div>
      <div v-else class="list-no">
        <el-divider content-position="center">暂无数据</el-divider>
      </div>
    </div>
  </div> -->
    <!-- 热门招聘 -->
    <div class="body-box-tzgg">
      <!-- Top -->
      <div class="tzgg-text">
        <div></div>
        <div class="tzgg-title">热门招聘</div>
        <div class="tzgg-more">
          <router-link
            class="more-tip"
            :to="{
              path: '/recruitList',
            }"
            >更多>>
          </router-link>
        </div>
      </div>
      <!-- 列表数据 -->
      <div class="tzgg-list">
        <div class="list-yes" v-if="hotNoticeList.length > 0">
          <template>
            <router-link
              :to="{
                path: '/recruitDetail',
                query: { id: item.id },
              }"
              class="tzgg-item"
              v-for="(item, index) in hotNoticeList"
              :key="index"
            >
              <div class="news-title">
                {{ item.title }}
              </div>
              <div class="date">{{ item.publishTime }}</div>
            </router-link>
          </template>
        </div>
        <div v-else class="list-no">
          <el-divider content-position="center">暂无数据</el-divider>
        </div>
      </div>
    </div>
    <!-- 热门岗位 -->
    <div class="body-box-rmgw">
      <div class="rmgw-top">
        <div></div>
        <div class="title">热门岗位</div>
      </div>
      <div class="rmgw-bottom">
        <div
          class="rmgw-item"
          v-for="(item, index) in hotPostList"
          :key="index"
          @click="goBaoming(item)"
        >
          <div class="job-title">
            <div class="title">{{ item.name }}</div>
            <div class="money">薪资:{{ item.salary }}</div>
          </div>
          <div class="job-info">
            {{ item.education }}
            | {{ item.majorDemand }} |
            {{ item.age }}
          </div>
          <div class="job-complate">{{ item.unit }}</div>
        </div>
      </div>
    </div>
    <!-- 通知公告 && 录用通知 -->
    <div class="body-box-tzgg">
      <!-- Top -->
      <div class="tzgg-text">
        <div></div>
        <div class="tzgg-title">通知公告</div>
        <div class="tzgg-more">
          <router-link
            class="more-tip"
            :to="{
              path: '/newsListInform',
              query: {
                categoryId: currentIndex == 2 ? 3 : 2,
              },
            }"
            >更多>>
          </router-link>
        </div>
      </div>
      <!-- 列表数据 -->
      <div class="tzgg-list">
        <div class="list-yes" v-if="groupNews.length > 0">
          <template>
            <router-link
              :to="{
                path: '/newsDetail',
                query: { id: item.id },
              }"
              class="tzgg-item"
              v-for="(item, index) in groupNews"
              :key="index"
            >
              <div class="news-title">
                {{ item.title }}
              </div>
              <div class="date">{{ item.publishTime }}</div>
            </router-link>
          </template>
        </div>
        <div v-else class="list-no">
          <el-divider content-position="center">暂无数据</el-divider>
        </div>
      </div>
    </div>
    <div class="body-box-qytj">
      <div class="qytj-top">
        <div></div>
        <div class="title">企业推荐</div>
      </div>
      <div class="qytj-bottom">
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj1.png" alt="" />
          <div class="title">石家庄国控城市发展投资集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj2.png" alt="" />
          <div class="title">石家庄交通投资发展集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj3.png" alt="" />
          <div class="title">石家庄国有资本投资运营集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj4.png" alt="" />
          <div class="title">石家庄水务投资集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img
            src="../../assets/newImg/qytj5.jpg"
            alt=""
            style="width: 75px; height: 75px"
          />
          <div class="title">石家庄文化旅游投资集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj6.png" alt="" />
          <div class="title">石家庄常山纺织集团有限责任公司</div>
        </div>
        <div class="qytj-item">
          <img src="../../assets/newImg/qytj7.png" alt="" />
          <div class="title">石家庄北国人百集团有限责任公司</div>
        </div>
        <div class="qytj-item" style="opacity: 0"></div>
      </div>
    </div>
    <div class="bottom-banner">
      <img src="../../assets/newImg/banner2.png" alt="" />
    </div>
    <div class="bottom-fwmk">
      <img src="../../assets/newImg/fwmk.png" alt="" />
    </div>
    <!-- 漂浮公告 开始 -->
    <div class="float-notice-wrap" v-if="noticeShow">
      <div class="float-notice" id="floatNotice">
        <div @click="itemClick(1)">📢 重要招聘公告，点击查看详情</div>
        <div @click="itemClick(2)">📢 重要招聘公告，点击查看详情</div>
      </div>
    </div>
    <!-- 漂浮公告 结束 -->

    <!-- 右下角圆形悬浮按钮 考试日历 -->
    <!-- 右下角圆形悬浮按钮 考试日历 -->
    <div class="exam-calendar-float-btn" @click="openExamCalendar">
      <div>📅</div>
      <div style="font-size: 14px">考试日历</div>
    </div>

    <!-- 考试日历弹窗 -->
    <el-dialog
      title="考试日历（笔试安排）"
      :visible.sync="examCalendarDialogVisible"
      width="640px"
    >
      <div class="exam-calendar-wrap">
        <div class="exam-section">
          <div class="section-title">即将进行</div>
          <div v-if="upcomingExamList.length === 0" class="empty-tip">
            暂无即将进行的笔试
          </div>
          <div
            class="exam-item upcoming"
            v-for="item in upcomingExamList"
            :key="item.id"
          >
            <div class="exam-time">{{ item.startTime }}</div>
            <div class="exam-name">{{ item.testName }}</div>
            <span class="tag tag-upcoming">即将进行</span>
          </div>
        </div>

        <div class="exam-section">
          <div class="section-title">历次笔试（历史）</div>
          <div v-if="historyExamList.length === 0" class="empty-tip">
            暂无历史笔试记录
          </div>
          <div
            class="exam-item finished"
            v-for="item in historyExamList"
            :key="item.id"
          >
            <div class="exam-time">{{ item.startTime }}</div>
            <div class="exam-name">{{ item.testName }}</div>
            <span class="tag tag-finished">已结束</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Swiper from "swiper";
// import "swiper/css/swiper.css";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  data() {
    return {
      //====考试日历新增====
      examCalendarDialogVisible: false,

      upcomingExamList: [],
      historyExamList: [],
      // ====== 漂浮公告变量 ======
      noticeShow: false,
      floatX: 120,
      floatY: 120,
      floatVx: 0.2,
      floatVy: 0.2,
      floatPause: false,
      floatAnimateId: null,
      // =========原有data内容不变=========
      treeList: [],
      title: "",
      dialogVisible: false,
      recruitNoticeList: [],
      dictList: [],
      particulars: "",
      currentIndex: 0,
      current: 0,

      enterpriseText: "",
      groupNews: [],
      noticeNews: [],
      showLoginBtn: false,
      authentication: "",
      bannerList: [],
      middleImageList: [],

      hotPostList: [],
      hotNoticeList: [],

      jianjieList: [
        {
          name: "人才招聘",
          id: 1,
          imgUrl: require("@/assets/jianjie/rczp.png"),
        },
        {
          name: "国企培训",
          id: 2,
          imgUrl: require("@/assets/jianjie/gqpx.png"),
        },

        {
          name: "人力资源外包",
          id: 4,
          imgUrl: require("@/assets/jianjie/zywb.png"),
        },
        {
          name: "人力咨询",
          id: 3,
          imgUrl: require("@/assets/jianjie/rlzx.png"),
        },
        {
          name: "劳务派遣",
          id: 5,
          imgUrl: require("@/assets/jianjie/lwpq.jpg"),
        },
        {
          name: "人才基地",
          id: 6,
          imgUrl: require("@/assets/jianjie/lt.png"),
        },
        {
          name: "留学服务",
          id: 7,
          imgUrl: require("@/assets/jianjie/bpo.png"),
        },
      ],
      jianjieInfo: {
        id: 1,
        imgUrl: require("@/assets/jianjie/rczp.png"),
      },
      hover: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: false,
      },
    };
  },
  filters: {
    weekday(val) {
      let title;
      if (val == 0) {
        title = "星期日";
      } else if (val == 1) {
        title = "星期一";
      } else if (val == 2) {
        title = "星期二";
      } else if (val == 3) {
        title = "星期三";
      } else if (val == 4) {
        title = "星期四";
      } else if (val == 5) {
        title = "星期五";
      } else if (val == 6) {
        title = "星期六";
      }
      return title;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    let href = window.location.href;
    if (href.indexOf("bsh_bid") > 0 || href.indexOf("courseDeatil") > 0) {
      let url = href.substring(href.indexOf("?") + 1, href.indexOf("&"));
      let urlArr = url.split("=");
      window.location.href =
        "http://" +
        window.location.host +
        "/#/" +
        urlArr[0] +
        "?id=" +
        urlArr[1];
    }
    this.getBannerList();

    // ==========新增：初始化漂浮公告==========
    this.$nextTick(() => {
      this.initFloatNotice();
    });
  },
  beforeUnmount() {
    // 清除动画帧
    if (this.floatAnimateId) {
      cancelAnimationFrame(this.floatAnimateId);
    }
    window.removeEventListener("scroll", this.scrollToTop);
  },

  created() {
    this.addVisitCount();
    this.getEnterpriseList();
    this.getNewList();
    this.getNoticeList();
    // this.getBannerList();
    this.getMiddleList();
    this.getHotPostList();
    this.handlerNavigation();
    this.getHotRecruit();
    // this.getCompanyList();
    this.authentication = this.$cookies.get(this.$commons.User.Authentication);
    // this.noticeShow=true
  },
  methods: {
    //打开考试日历弹窗
    openExamCalendar() {
      this.examCalendarDialogVisible = true;
      this.getExamCal();
    },
    //分割即将/历史考试
    getExamCal() {
      let _this = this;
      //获取历史考试
      let param1={
        reminder:1,
        examStatus:2,
        isDeleted:0
      }
      _this.$api.examination.getRemindExam(param1).then((res) => {
        console.log("res1", res);
        _this.historyExamList=res.data

      });
      //获取即将进行的考试
      let param2={
        reminder:1,
        examStatus:0,
        isDeleted:0
      }
      _this.$api.examination.getRemindExam(param2).then((res) => {
        console.log("res2", res);
        _this.upcomingExamList=res.data
      });
    },

    itemClick(val) {
      console.log("11", val);
    },
    // 漂浮公告动画初始化
    initFloatNotice() {
      const noticeDom = document.getElementById("floatNotice");
      if (!noticeDom) return;

      // 鼠标移入暂停
      noticeDom.addEventListener("mouseenter", () => {
        this.floatPause = true;
      });
      // 鼠标移出继续
      noticeDom.addEventListener("mouseleave", () => {
        this.floatPause = false;
      });

      const animateLoop = () => {
        if (!this.floatPause) {
          const winW = window.innerWidth;
          const winH = window.innerHeight;
          const boxW = noticeDom.offsetWidth;
          const boxH = noticeDom.offsetHeight;

          this.floatX += this.floatVx;
          this.floatY += this.floatVy;

          // 边界碰撞反弹
          if (this.floatX <= 0 || this.floatX + boxW >= winW) {
            this.floatVx = -this.floatVx;
          }
          if (this.floatY <= 0 || this.floatY + boxH >= winH) {
            this.floatVy = -this.floatVy;
          }

          noticeDom.style.left = this.floatX + "px";
          noticeDom.style.top = this.floatY + "px";
        }
        this.floatAnimateId = requestAnimationFrame(animateLoop);
      };
      animateLoop();
    },

    addVisitCount() {
      let _this = this;
      _this.$api.visit
        .addVisitCount()
        .then((res) => {})
        .catch(() => {});
    },
    getHotRecruit() {
      let _this = this;
      _this.$api.recruitNotice.getHotNoticeList().then((res) => {
        console.log("res", res);
        _this.hotNoticeList = res.data;
      });
    },
    handlerNavigation() {
      let _this = this;
      _this.$api.news.articleTreeList().then((response) => {
        this.treeList = response.data;
      });
    },
    handlerNavigationParticulars(name) {
      let _this = this;
      _this.dialogVisible = true;
      _this.title = name;
      _this.$api.news
        .handlerNavigationParticulars({ particulars: name })
        .then((response) => {
          if (response.code == this.$commons.RespCode.success) {
            _this.recruitNoticeList = response.data;
            if (this.dictList.length > 0) {
              this.handleData();
            } else {
              this.getByDicType();
            }
            _this.total = Number(response.total);
          }
        });
    },
    handleIndex(val) {
      this.currentIndex = val;
    },
    handler(val) {
      this.current = val;
    },

    titleTagChange(item) {
      let _this = this;
      _this.titleTag = item.id;
    },
    goDetail(item) {
      console.log("item", item);
      let _this = this;
      if (item.sourceType == 3) {
        _this.$router.push({
          path: "/newsDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 2) {
        _this.$router.push({
          path: "/recruitDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 1) {
        window.open(item.linkUrl, "_blank");
      }
    },
    // 企业简介
    getEnterpriseList() {
      let _this = this;
      let parmas = {
        categoryId: 1,
      };
      _this.$api.news
        .enterpriseList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.enterpriseText = res.data.content;
          }
        })
        .catch(() => {});
    },
    // 通知公告
    getNewList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 5,
        categoryId: 2,
      };
      _this.$api.news
        .articleList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.groupNews = res.rows;
          }
        })
        .catch(() => {});
    },
    // 录用通知
    getNoticeList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 5,
        categoryId: 3,
      };
      _this.$api.news
        .articleList(parmas)
        .then((res) => {
          console.log(res);
          if (res.code == _this.$commons.RespCode.success) {
            _this.noticeNews = res.rows;
          }
        })
        .catch(() => {});
    },
    getBannerList() {
      let that = this;
      let params = {
        pageNum: 1,
        pageSize: 8,
        advZoneId: 1,
        status: 1,
      };
      that.$api.advertisement
        .list(params)
        .then((res) => {
          if (res.code === that.$commons.RespCode.success) {
            that.bannerList = res.rows;
            console.log("bannerList", that.bannerList);
            that.$nextTick(function () {
              new Swiper(".swiper-container", {
                spaceBetween: 30,
                // 默认active slide居左，设置为true后居中
                centeredSlides: true,
                autoplay: {
                  delay: 5000, // 5 秒
                  // false: 触碰后不会停止自动切换
                  disableOnInteraction: false,
                },
                // 分页导航
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                // 左右切换按钮
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            });
          }
        })
        .catch(() => {});
    },
    getMiddleList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 8,
        // 怎么设置成动态？
        advZoneId: 2,
        status: 1,
      };
      _this.$api.advertisement
        .list(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.middleImageList = res.rows;
          }
        })
        .catch(() => {});
    },
    getHotPostList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        // 热门岗位 通过改这个属性值 就可以改变前端的展示数量-----默认是 8
        pageSize: 16,
        hot: 1,
      };
      _this.$api.post
        .getList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.hotPostList = res.rows;
            // console.log("hotPostList", _this.hotPostList);
          }
        })
        .catch(() => {});
    },
    getCompanyList() {
      let _this = this;
      _this.$api.company
        .getCompanyList()
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            if (res.rows.length > 0) {
              _this.companyList = res.rows;
            }
          }
        })
        .catch(() => {});
    },
    goBaoming(item) {
      this.$router.push({
        path: "/recruitDetail",
        query: { id: item.noticeId },
      });
    },
    getDate() {
      var aData = new Date();
      this.nowDate =
        aData.getFullYear() +
        "年" +
        (aData.getMonth() + 1) +
        "月" +
        aData.getDate() +
        "日";
      this.weekday = aData.getDay();
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 500) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    goTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },

    kefu() {
      let _this = this;
      window.open("http://wpa.qq.com/msgrd?v=3&uin=12345645&site=qq&menu=yes");
    },
    showJianjie(item) {
      let _this = this;
      _this.jianjieInfo = item;
    },
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          // done();
          this.dialogVisible = false;
        })
        .catch((_) => {});
    },
    handleData() {
      let _this = this;
      _this.recruitNoticeList.forEach((item) => {
        _this.dictList.forEach((dic) => {
          if (dic.dictValue == item.status) {
            _this.$set(item, "statusName", dic.dictLabel);
          }
        });
      });
    },
    getByDicType() {
      let _this = this;
      let param = {
        dictType: "re_notice_status",
      };
      _this.$api.system
        .getDicByCode(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            this.dictList = res.data;
            this.handleData();
          }
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      // this.pageNum = val;
      this.getRecruitNoticeList();
    },
    goTo(id, status) {
      // if (status == 1 || status == 0) {
      this.$router.push({ path: "/recruitDetail", query: { id: id } });
      // }
    },
  },
  // computed: {
  //     // 使用计算属性过滤 parentId 为 0 的数据
  //     filteredData() {
  //         if (Array.isArray(this.treeList)) {
  //             return this.treeList.filter(item => item.parentId === 0);
  //         } else {
  //             // 如果不是数组，进行适当的处理，比如返回一个空数组
  //             return [];
  //         }
  //     }
  // },
};
</script>

<!-- <style>
.el-dialog__body {
    padding: 0px 20px 15px 20px;
    background: rgb(240, 241, 244);
}
</style> -->

<style scoped>
.body-container {
  background-color: rgba(164, 171, 189, 0.16);
  width: 100%;
  height: 40%;
}

.body-container .body-box-top {
  max-width: 1200px;
  margin: 24px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body-container .body-box-top .left-box {
  width: 17%;
  background-color: #fff;
  position: relative;
}

.body-container .body-box-top .left-box .left-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  height: 40px;
  border-bottom: 1px solid #ddd;
  margin-top: 2px;
  cursor: pointer;
  /* position: relative; */
}

.body-container .body-box-top .left-box .left-item .menu-panel {
  position: absolute;
  width: 308%;
  top: 0.3%;
  right: -308%;
  height: 418px;
  background: rgb(255, 255, 255);
  display: none;
  z-index: 999;
}

.body-container .body-box-top .left-box .left-item:hover .menu-panel {
  display: block;
  padding: 17px 19px;
  z-index: 999;
}

.body-container
  .body-box-top
  .left-box
  .left-item:hover
  .menu-panel
  .panel-title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  margin-bottom: 15px;
}

.body-container
  .body-box-top
  .left-box
  .left-item:hover
  .menu-panel
  .panel-item {
  border-top: 1px solid rgb(242, 249, 255);
  margin-top: 15px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  text-align: center;
}

.body-container
  .body-box-top
  .left-box
  .left-item:hover
  .menu-panel
  .panel-item
  .item {
  margin-top: 18px;
  width: 25%;
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
}

.body-container
  .body-box-top
  .left-box
  .left-item:hover
  .menu-panel
  .panel-item
  .item:hover {
  color: rgb(64, 112, 179);
}

.body-container .body-box-top .left-box .left-item.active,
.body-container .body-box-top .left-box .left-item:hover {
  background: rgb(64, 112, 179);
}

.body-container .body-box-top .left-box .left-item .label {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: unset;
}

.body-container .body-box-top .left-box .left-item.active .label,
.body-container .body-box-top .left-box .left-item:hover .label {
  color: rgb(255, 255, 255);
}

.body-container .body-box-top .left-box .left-item.active img,
.body-container .body-box-top .left-box .left-item:hover img {
  content: url("../../assets/newImg/right_avtive.png");
}

.body-container .body-box-top .swiper-box {
  width: 50%;
  background-color: #fff;
  height: 419px;
  position: relative;
}

.body-container .body-box-top .right-box {
  width: 30%;
  background-color: #fff;
  height: 419px;
  position: relative;
}

.body-container .body-box-top .right-box .tabs {
  width: 100%;
  height: 56px;
  border-bottom: 2px solid rgb(64, 112, 179);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.body-container .body-box-top .right-box .tabs .tab-item {
  width: 33%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.body-container .body-box-top .right-box .tabs .tab-item img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.body-container .body-box-top .right-box .tabs .tab-item .text {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
}

.body-container .body-box-top .right-box .tabs .tab-item.active {
  width: 33%;
  background-color: rgb(64, 112, 179);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
}

.body-container .body-box-top .right-box .tabs .tab-item.active .text {
  color: rgb(255, 255, 255);
}

.body-container .body-box-top .right-box .tabs-content {
  width: 100%;
  /* min-height: 370px; */
  /* position: relative; */
}

.body-container .body-box-top .right-box .tabs-content .tabs-content-qyjj {
  padding: 20px 16px;
  line-height: 33px;
  text-indent: 1cm;
}

.body-container .body-box-top .right-box .tabs-content .tabs-content-tzgg,
.body-container .body-box-top .right-box .tabs-content .tabs-content-lytz {
  padding: 16px;
}

/* .body-container .body-box-top .right-box .tabs-content .tabs-content-tzgg .tzgg-item,
.body-container .body-box-top .right-box .tabs-content .tabs-content-lytz .tzgg-item {
  text-decoration: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #eee;
} */

/* .body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-tzgg
  .tzgg-item
  .news-title,
.body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-lytz
  .tzgg-item
  .news-title {
  width: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
} */

.body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-tzgg
  .tzgg-item
  .date,
.body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-lytz
  .tzgg-item
  .date {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
}

.body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-tzgg
  .more-tip,
.body-container
  .body-box-top
  .right-box
  .tabs-content
  .tabs-content-lytz
  .more-tip {
  text-decoration: none;
  position: absolute;
  right: 3%;
  bottom: 5%;
}

.body-container .body-box-banner {
  max-width: 1200px;
  margin: 24px auto;
}

.body-container .body-box-banner img {
  width: 100%;
  margin-bottom: 10px;
  cursor: pointer;
}

.body-container .body-box-tzgg,
.body-container .body-box-lytz,
.body-container .body-box-rmgw,
.body-container .body-box-qytj {
  max-width: 1200px;
  margin: 14px auto 24px;
  background-color: #fff;
  border-radius: 8px;
  /* height: 300px; */
}

.body-container .body-box-tzgg .tzgg-text,
.body-container .body-box-lytz .lytz-text,
.body-container .body-box-rmgw .rmgw-top,
.body-container .body-box-qytj .qytj-top {
  height: 54px;
  border-bottom: 2px solid rgb(64, 112, 179);
  display: flex;
  align-items: center;
}

.body-container .body-box-tzgg .tzgg-text div:nth-child(1),
.body-container .body-box-lytz .lytz-text div:nth-child(1),
.body-container .body-box-rmgw .rmgw-top div:nth-child(1),
.body-container .body-box-qytj .qytj-top div:nth-child(1) {
  width: 4px;
  height: 20px;
  background: rgb(64, 112, 179);
  margin: 0px 16px;
}

.body-container .body-box-rmgw .rmgw-top .title,
.body-container .body-box-qytj .qytj-top .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
}

.body-container .body-box-tzgg .tzgg-text .tzgg-title,
.body-container .body-box-lytz .lytz-text .lytz-title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  float: left;
  width: 90%;
}

.body-container .body-box-tzgg .tzgg-list,
.body-container .body-box-lytz .lytz-list {
  width: 100%;
}

.body-container .body-box-tzgg .tzgg-list .list-yes,
.body-container .body-box-lytz .lytz-list .list-yes {
  width: 100%;
  height: 100%;
}

.body-container .body-box-tzgg .tzgg-list .list-yes .tzgg-item,
.body-container .body-box-lytz .lytz-list .list-yes .tzgg-item {
  margin-left: 15px;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #eee;
}

.body-container .body-box-tzgg .tzgg-list .list-yes .news-title,
.body-container .body-box-lytz .lytz-list .list-yes .news-title {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
}

.body-container .body-box-tzgg .tzgg-list .list-yes .date,
.body-container .body-box-lytz .lytz-list .list-yes .date {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
  width: 10%;
  text-align: right;
  margin-right: 30px;
}

.body-container .body-box-tzgg .tzgg-list .list-no,
.body-container .body-box-lytz .lytz-list .list-no {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.body-container .body-box-rmgw .rmgw-bottom,
.body-container .body-box-qytj .qytj-bottom {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item {
  width: 24.5%;
  padding: 15px 16px;
  background: rgb(242, 249, 255);
  margin-bottom: 8px;
  min-height: 185px;
  cursor: pointer;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item .job-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item .job-title .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item .job-title .money {
  color: rgb(255, 87, 53);
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item .job-info {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
  margin: 16px 0px;
}

.body-container .body-box-rmgw .rmgw-bottom .rmgw-item .job-complate {
  color: rgb(64, 112, 179);
  font-family: PingFang SC;
  font-size: 14px;
}

.body-container .body-box-qytj .qytj-bottom .qytj-item {
  padding: 20px;
  width: 24.5%;
  min-height: 160px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 0px 8px rgba(164, 171, 189, 0.48);
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.body-container .body-box-qytj .qytj-bottom .qytj-item .title {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
}

.body-container .bottom-banner {
  max-width: 1200px;
  margin: 24px auto;
}

.body-container .bottom-fwmk {
  max-width: 1200px;
  margin: 24px auto;
}

.search-res {
  max-width: 1200px;
  margin: 24px auto 0px;
  /* display: flex; */
  /* justify-content: space-between; */
}

.search-res .left-box-two {
  width: 79%;
}

.search-res .left-box-two .res-item {
  background-color: #fff;
  padding: 18px 16px;
  margin-bottom: 24px;
}

.search-res .left-box-two .pages {
  text-align: center;
  margin: 50px auto;
}

.search-res .left-box-two .res-item .top-res {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px 20px;
}

.search-res .left-box-two .res-item .top-res .title-two {
  color: rgb(64, 71, 86);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-res .left-box-two .res-item .top-res .date-two {
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 14px;
}

.search-res .left-box-two .res-item .top-res .type {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
}

.search-res .left-box-two .res-item .top-res .button-start {
  width: 144px;
  height: 40px;
  background: rgb(64, 112, 179);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.search-res .left-box-two .res-item .top-res .button-over {
  width: 144px;
  height: 40px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(164, 171, 189);
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: rgb(164, 171, 189);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.search-res .left-box-two .res-item .top-res .type span {
  font-size: 24px;
  color: rgb(64, 112, 179);
}

.search-res .right-box {
  width: 20%;
}

.search-res .right-box img {
  width: 100%;
  margin-bottom: 24px;
  cursor: pointer;
  min-height: 200px;
  object-fit: cover;
}

/* 漂浮公告样式 */
.float-notice-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
}
.float-notice {
  position: absolute;
  padding: 10px 18px;
  background: #4070b3;
  color: #fff;
  border-radius: 6px;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  pointer-events: auto;
  transition: opacity 0.2s;
}
.float-notice:hover {
  opacity: 0.85;
}

/*右下角圆形悬浮按钮*/
.exam-calendar-float-btn {
  position: fixed;
  right: 30px;
  bottom: 60px;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: #4070b3;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9998;
  box-shadow: 0 2px 12px rgba(64, 112, 179, 0.35);
}
.exam-calendar-float-btn:hover {
  opacity: 0.88;
}

/*考试日历弹窗内部样式*/
.exam-calendar-wrap {
  max-height: 60vh;
  overflow-y: auto;
}
.exam-section {
  margin-bottom: 16px;
}
.section-title {
  font-size: 15px;
  font-weight: bold;
  margin: 12px 0 10px;
  color: #333;
  border-left: 4px solid #4070b3;
  padding-left: 8px;
}
.exam-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
}
.exam-item.upcoming {
  background-color: #f0f7ff;
  border-color: #94c4ff;
}
.exam-item.finished {
  background-color: #f7f7f7;
  border-color: #dddddd;
  color: #777;
}
.exam-time {
  width: 180px;
  font-size: 15px;
  font-weight: bold;
}
.exam-name {
  flex: 1;
  font-size: 15px;
}
.tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
}
.tag-upcoming {
  background: #e6f0ff;
  color: #4070b3;
}
.tag-finished {
  background: #eeeeee;
  color: #666666;
}
.empty-tip {
  text-align: center;
  color: #999;
  padding: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index1.vue